import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";

export default function useRemoveTransfer() {
  const queryClient = useQueryClient();

  const removeTransfer = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.transfers.remove, { id }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(removeTransfer, {
    onSettled: (data, error, id) => {
      queryClient.invalidateQueries([ENDPOINTS.transfers.one, id]);
      queryClient.invalidateQueries([ENDPOINTS.transfers.all]);
    },
  });

  return { data, mutate, ...rest };
}
